import(/* webpackMode: "eager" */ "/home/runner/work/my010-frontend-web/my010-frontend-web/src/app/global-error.tsx");
